import React, { useState } from 'react';

import { ActionIcon, CopyIcon } from 'components/Icon';

interface Props
{
  text?: string,
  tip?: string,
  successText?: string,
}
const CopyToClipboard: React.FC<Props> = ({text, tip, successText}) =>
{
  const [success, setSuccess] = useState(false);
  const copyToClipboardHandler = async () =>
  {
    try
    {
      await navigator.clipboard.writeText(text || '');
      setSuccess(prev => true);
    }
    catch
    {
      setSuccess(prev => false);
    }
  };
  return (
    <ActionIcon action={copyToClipboardHandler} tip={tip} className="clipboard">
      <CopyIcon />{success ? <span>{successText}</span> : ''}
    </ActionIcon>
  );
};

export default CopyToClipboard;